import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaShoppingCart, FaUser, FaSignOutAlt, FaBars, FaTimes, FaChartLine, FaUsers, FaWineBottle } from 'react-icons/fa';
import { useAuthStore, useCartStore } from '../context/store';
import '../styles/Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, isAuthenticated, logout } = useAuthStore();
  const { getTotalItems } = useCartStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const cartItems = getTotalItems();

  return (
    <nav className="navbar">
      <div className="navbar-age-banner">
        Vendita vietata ai minori di 18 anni. Consumare responsabilmente.
      </div>
      <div className="container navbar-content">
        <Link to="/" className="navbar-brand">
          <img className="navbar-logo" src="/logowineico.png" alt="Cà del Vin" />
        </Link>

        <button className="navbar-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/catalogo" className="navbar-link" onClick={() => setIsMenuOpen(false)}>
            Catalogo
          </Link>
          <Link to="/info-legali" className="navbar-link" onClick={() => setIsMenuOpen(false)}>
            Info Legali
          </Link>

          {isAuthenticated && (user?.ruolo === 'admin' || user?.ruolo === 'superadmin') && (
            <>
              <Link to="/crm" className="navbar-link" onClick={() => setIsMenuOpen(false)}>
                <FaUsers /> CRM
              </Link>
              <Link to="/admin" className="navbar-link" onClick={() => setIsMenuOpen(false)}>
                <FaChartLine /> Admin
              </Link>
            </>
          )}

          <Link to="/carrello" className="navbar-link cart-link" onClick={() => setIsMenuOpen(false)}>
            <FaShoppingCart />
            {cartItems > 0 && <span className="cart-badge">{cartItems}</span>}
          </Link>

          {isAuthenticated ? (
            <>
              <Link to="/cantina" className="navbar-link" onClick={() => setIsMenuOpen(false)}>
                <FaWineBottle /> La mia cantina
              </Link>
              <Link to="/profilo" className="navbar-link" onClick={() => setIsMenuOpen(false)}>
                <FaUser /> {user?.nome}
              </Link>
              <button onClick={handleLogout} className="navbar-link btn-logout">
                <FaSignOutAlt /> Logout
              </button>
            </>
          ) : (
            <Link to="/login" className="btn btn-primary" onClick={() => setIsMenuOpen(false)}>
              Accedi
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
